import { observer } from 'mobx-react'

function LecturesScreen() {
    return (
        <div>coming soon...</div>
    )
}

export default observer(LecturesScreen);